import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine, RevealImage } from "../components/Reveal";
import WorldMap from "../components/WorldMap";

const PORT_IMG = "/images/network.webp";

export default function Network() {
  const { t } = useLang();
  return (
    <div className="bg-[#050607]" data-testid="network-page">
      <section className="px-5 md:px-10 pt-40 pb-16 md:pt-48 md:pb-24">
        <FadeUp><div className="eyebrow mb-8">{t("network.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[36px] sm:text-[54px] lg:text-[68px] text-[#F3F3F0] max-w-5xl">
          {t("network.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14} className={i === 1 ? "text-[#999995]" : ""}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-8 max-w-2xl text-[15px] md:text-[16px] leading-relaxed text-[#999995]">{t("network.sub")}</p></FadeUp>
      </section>

      <section className="px-5 md:px-10 pb-20">
        <FadeUp>
          <div className="eyebrow mb-5">{t("network.mapTitle")}</div>
          <WorldMap />
        </FadeUp>
        <FadeUp delay={0.1}>
          <p className="mt-6 max-w-2xl text-[12px] leading-relaxed text-[#666663]">{t("network.note")}</p>
        </FadeUp>
      </section>

      <section className="px-5 md:px-10 pb-24 md:pb-32 border-t border-white/10 pt-16" data-testid="network-reach">
        <div className="max-w-3xl mb-14">
          <FadeUp><div className="eyebrow mb-8">{t("network.reach.eyebrow")}</div></FadeUp>
          <h2 className="font-display text-[30px] sm:text-[44px] lg:text-[52px] text-[#F3F3F0]">
            {t("network.reach.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={i * 0.14} className={i === 1 ? "text-[#999995]" : ""}>{l}</InviewMaskLine>)}
          </h2>
          <FadeUp delay={0.2}><p className="mt-6 text-[14px] md:text-[15px] leading-relaxed text-[#999995]">{t("network.reach.intro")}</p></FadeUp>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-white/10">
          {t("network.reach.items").map((item, i) => (
            <FadeUp key={item.t} delay={i * 0.07} className="border-b border-r border-white/10 p-7 md:p-9 hover:bg-white/[0.025] transition-colors duration-500" data-testid={`reach-block-${i + 1}`}>
              <div className="mono text-[11px] text-[#555654] mb-8">{String(i + 1).padStart(2, "0")}</div>
              <h3 className="mono text-[12px] tracking-[0.2em] text-[#F3F3F0] mb-4 leading-relaxed">{item.t}</h3>
              <p className="text-[13px] leading-relaxed text-[#8A8A86]">{item.d}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.15}>
          <p className="mt-8 max-w-2xl text-[12px] leading-relaxed text-[#666663]">{t("network.note")}</p>
        </FadeUp>
      </section>
    </div>
  );
}
